import type { TrigKey } from './keys';

export const uk: Partial<Record<TrigKey, string>> = {
  'app.eyebrow': 'Математика · Тригонометрія',
  'panel.experiment': 'Експеримент',
  'panel.params': 'Параметри',
  'panel.scene': 'Виберіть експеримент',
  'experiment.right-triangle.label': 'Прямокутний трикутник',
  'experiment.unit-circle.label': 'Одиничне коло',
  'experiment.wave-studio.label': 'Студія хвиль',
  'experiment.identity-playground.label': 'Тотожності',
  'experiment.triangle-solver.label': 'Розв’язувач трикутника',
  'experiment.circular-polar.label': 'Кругова та полярна',
  'hint.line1': 'Тягніть точки, рухайте повзунки.',
  'hint.line2': 'Навчальний зміст живе в геометрії, а не в тексті.',
  'rt.angle.a': 'Кут A',
  'rt.angle.b': 'Кут B',
  'rt.angle.value': '∠',
  'rt.units.rad': 'Радіани',
  'rt.show.sin': 'sin',
  'rt.show.cos': 'cos',
  'rt.show.tan': 'tg',
  'rt.snap': 'Прив’язка до 30°/45°/60°',
  'uc.units': 'Одиниці',
  'uc.show.sin': 'sin',
  'uc.show.cos': 'cos',
  'uc.show.tan': 'tg',
  'uc.show.csc': 'csc',
  'uc.show.sec': 'sec',
  'uc.show.cot': 'ctg',
  'uc.show.astc': 'Показати ASTC',
  'uc.snap.common': 'Прив’язка до стандартних кутів',
  'uc.angle.value': '∠',
  'uc.units.deg': 'град',
  'uc.units.rad': 'рад',
  'uc.units.both': 'град+рад',
  'ws.fn': 'Функція',
  'ws.fn.sin': 'sin',
  'ws.fn.cos': 'cos',
  'ws.fn.tan': 'tg',
  'ws.fn.csc': 'csc',
  'ws.fn.sec': 'sec',
  'ws.fn.cot': 'ctg',
  'ws.amplitude': 'A — Амплітуда',
  'ws.frequency': 'B — Частота',
  'ws.phase': 'C — Зсув фази',
  'ws.shift': 'D — Вертикальний зсув',
  'ws.rform.toggle': 'Виведення R-форми',
  'ws.rform.a': 'a (коеф. sin)',
  'ws.rform.b': 'b (коеф. cos)',
  'ws.rform.r': 'R',
  'ws.rform.alpha': 'α',
  'ws.reset': 'Скинути',
  'ws.base': 'Показати базову криву',
  'ip.id.pythagorean': 'Піфагорова',
  'ip.id.reciprocal': 'Обернена',
  'ip.id.quotient': 'Частки',
  'ip.id.sum': 'Суми',
  'ip.id.difference': 'Різниці',
  'ip.id.double': 'Подвійного кута',
  'ip.id.half': 'Половини кута',
  'ip.play': 'Відтворити',
  'ip.pause': 'Пауза',
  'ip.step': 'Крок',
  'ip.reset': 'Скинути',
  'ip.proof.pythagorean.summary': 'sin²θ + cos²θ = 1',
  'ip.proof.reciprocal.summary': 'csc θ = 1/sin θ,  sec θ = 1/cos θ,  ctg θ = 1/tg θ',
  'ip.proof.quotient.summary': 'tg θ = sin θ / cos θ',
  'ip.proof.sum.summary': 'sin(A+B) = sin A cos B + cos A sin B',
  'ip.proof.difference.summary': 'sin(A−B) = sin A cos B − cos A sin B',
  'ip.proof.double.summary': 'sin 2θ = 2 sin θ cos θ',
  'ip.proof.half.summary': 'sin(θ/2) = ±√((1 − cos θ)/2)',
  'ip.proof.v2.note': 'У v2 — для цього доведення потрібна більш ретельна побудова.',
  'ts.area': 'Площа',
  'ts.sineRule': 'Теорема синусів',
  'ts.cosineRule': 'Теорема косинусів',
  'ts.ambiguous.toggle': 'Привид при неоднозначності',
  'ts.reset': 'Скинути до рівностороннього',
  'ts.snap.integers': 'Прив’язка до цілих',
  'ts.side.a': 'a',
  'ts.side.b': 'b',
  'ts.side.c': 'c',
  'ts.angle.A': 'A',
  'ts.angle.B': 'B',
  'ts.angle.C': 'C',
  'ts.section.sides': 'Сторони',
  'ts.section.angles': 'Кути',
  'ts.section.sineRule': 'Теорема синусів',
  'ts.section.cosineRule': 'Теорема косинусів',
  'ts.section.area': 'Площа',
  'cp.omega': 'Кутова швидкість',
  'cp.plot.y': 'Графік y (sin)',
  'cp.plot.x': 'Графік x (cos)',
  'cp.polar.label': 'Полярна фігура',
  'cp.polar.circle': 'Коло (r = 1)',
  'cp.polar.rose': 'Троянда (r = sin 3θ)',
  'cp.polar.cardioid': 'Кардіоїда (r = 1 + cos θ)',
  'cp.polar.limacon': 'Лімасон (r = 1 − 2 cos θ)',
  'cp.smallAngle': 'Малі кути (sin x ≈ x)',
  'cp.play': 'Відтворити',
  'cp.pause': 'Пауза',
  'cp.reset': 'Скинути',
  'cp.step': 'Крок π/12',
};
